import { styled } from "../../../../styles";

export const ImageContainer = styled("div", {
  overflowY: "overlay",
  maxHeight: "100%",

  zIndex: 1000,

  borderRadius: "8px",

  width: "100%",
  minHeight: "426px",

  border: "1px solid #ECECEC",
  backgroundColor: "$white",
  color: "$black",

  boxSizing: "border-box",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  rowGap: "10px",

  p: {
    width: "418px",
    marginTop: "30px",
    textAlign: "center",

    button: {
      background: "none",
      color: "#7562A8",
      border: "none",
      padding: 0,
      font: "inherit",
      cursor: "pointer",
      outline: "inherit",
      fontWeight: "600",
    },
  },
});

export const ManageMessagesTitle = styled("div", {
  color: "$charcoal",
  fontWeight: "600",
  fontSize: "12px",
  lineHeight: "17px",
  cursor: "pointer",
  position: "absolute",
  top: "8px",
  right: "10px",
  borderRadius: "6px",
  padding: "0 2px",

  "&:hover": {
    color: "var(--colors-portal-small-add-button-hover)",
  },

  variants: {
    disabled: {
      true: {
        opacity: "0.5",
        cursor: "not-allowed",
        "&:hover": {
          color: "$charcoal",
        },
      },
    },
  },
});

export const TooltipContainer = styled("div", {
  display: "flex",
  justifyContent: "left",
  alignItems: "left",
});

/**
 * Tooltip body text. Mirrors the RAG indicator's TooltipLine (patient list) so tooltips read
 * the same everywhere: Open Sans, 12px/18px, white on $charcoal.
 *
 * This has to be a styled component rather than an entry in `tooltipStyles` below: that object
 * is handed to antd as INLINE styles, where stitches tokens ($white, $openSans, $text-md) and
 * nested selectors (h4, p) don't resolve — which is why every call site also passes
 * color="#4B4B4B" to antd to get the background it wants.
 */
export const TooltipText = styled("div", {
  fontFamily: "$openSans",
  fontSize: "$text-md",
  lineHeight: "18px",
  color: "$white",
  fontWeight: 400,
});

export const tooltipStyles = {
  borderRadius: "4px !important",
  fontSize: "12px",
  padding: "12px 16px",

  display: "flex",

  backgroundColor: "$charcoal",

  h4: {
    color: "$white",
    fontFamily: "$openSans",
    fontSize: "$text-md",
    lineHeight: "16px",
    marginBottom: "4px",

    fontWeight: 500,

    "&:last-child": {
      marginBottom: "8px",
    },
  },

  p: {
    color: "$gray-60",

    fontWeight: 500,
    fontFamily: "$openSans",
    fontSize: "$text-md",

    lineHeight: "16px",
  },
};

export const MessagesTableContainer = styled("div", {
  width: "100%",
  height: "420px",
  fontSize: "14px",
  minHeight: "420px",
  overflow: "auto",
});

export const MessagesTableInnerContainer = styled("div", {
  width: "100%",
  height: "420px",
  fontSize: "14px",
  minHeight: "420px",
  overflow: "auto",

  "@media screen and (max-width: 1100px)": {
    width: "1000px",
  },
});

export const NoContentMessage = styled("p", {
  marginTop: "10px !important",

  fontFamily: "$openSans",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "21px",
});
